import React, {useState, useEffect} from "react"
import Layout from "../../Layout"
import Footer from "../Footer"
import carYunOsLogo from "../../../static/mobile/pages/softWare/carYunOsLogo.png"
import linkToCaryunOs from "../../../static/mobile/pages/softWare/linkToCaryunOs.png"
import downloadApp from "../../../static/mobile/pages/softWare/downloadApp.png"
import downloadIcon from "../../../static/mobile/pages/softWare/downloadIcon.png"
import linkIcon from "../../../static/mobile/pages/softWare/linkIcon.png"

import {Image} from "antd-mobile"
import PaddingBox from "../PaddingBox"
import Text from "../Text"

const buttonStyle = {
	display: "flex",
	backgroundColor: "#FFFFFF",
	width: "90px",
	height: "34px",
	lineHeight: "34px",
	paddingLeft: "23px",
	borderRadius: "17px",
	boxSizing: "border-box",
	marginTop: "20px",
	color: "#00AA84",
	backgroundImage: `url(${downloadIcon})`,
	backgroundRepeat: "no-repeat",
	backgroundSize: "14px 14px",
	backgroundPosition: "left 56px center"
}

const toCarYunOs = () => {
	window.location.href = "https://caryunos.com"
}

const toDownloadApp = () => {
	window.location.href = "https://sj.qq.com/appdetail/com.autocareai.youchelai"
}


const MSoftWare = () => {
	return (
		<Layout background={'#00AA84'}>
			<PaddingBox pt={125} style={{width: "100vw", minHeight: "calc(100vh + 40px)"}}>
				<Image src={carYunOsLogo} width={108} height={25}/>

				<Text top={45} fontFamily="bold" fontSize={28} color="#FFFFFF" style={{textAlign: "center"}}>
					车云AI操作系统
				</Text>

				<Text fontWeight={100}
					  top={15}
					  fontFamily="normal"
					  fontSize={14}
					  color="#FFFFFF"
					  style={{textAlign: "center", letterSpacing: "3.5px"}}>
					让门店经营插上AI的翅膀
				</Text>

				<PaddingBox top={30} pad={45} pt={30} pb={30}
							style={{
								background: "#00C69A",
								border: "0.5px solid #00DFAD",
								borderRadius: "15px",
								display: "flex",
							}}>
					<Image src={linkToCaryunOs} width={110} height={110}/>
					<div style={{marginLeft: "35px"}}>
						<Text top={15} fontFamily="bold" fontSize={22} color="#FFFFFF">
							直接访问
						</Text>
						<div onClick={toCarYunOs}
							 style={{
								 ...buttonStyle,
								 backgroundImage: `url(${linkIcon})`,
								 backgroundSize: "15px 14px"
							 }}>
							进入
						</div>
					</div>
				</PaddingBox>

				<PaddingBox top={20} pad={45} pt={30} pb={30}
							style={{
								background: "#00C69A",
								border: "0.5px solid #00DFAD",
								borderRadius: "15px",
								display: "flex",
							}}>
					<Image src={downloadApp} width={110} height={110}/>
					<div style={{marginLeft: "30px"}}>
						<Text top={15} fontFamily="bold" fontSize={22} color="#FFFFFF">
							下载APP
						</Text>
						<div onClick={toDownloadApp}
							 style={{
								 ...buttonStyle,
								 backgroundImage: `url(${downloadIcon})`
							 }}>
							下载
						</div>
					</div>
				</PaddingBox>

				<Footer style={{marginTop: 65, marginBottom: 15}}/>
			</PaddingBox>
		</Layout>
	)
}

export default MSoftWare
